import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-oven-comment-dialog',
  standalone: true,
   imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule
  ],
  templateUrl: './oven-comment-dialog.component.html',
  styleUrl: './oven-comment-dialog.component.scss'
})
export class OvenCommentDialogComponent {
  comment: string = '';

  constructor(public dialogRef: MatDialogRef<OvenCommentDialogComponent>) {}

  submit() {
    if (this.comment.trim()) {
      this.dialogRef.close(this.comment);
    }
  }

}
